import * as React from 'react'
import { breakpoint, styled } from '../styled-components'
import { Text } from './Elements'
import { Utils } from '../Utils'
import { CalculatorStoreInstance } from '../../stores/CalculatorStore'
import { inject } from 'mobx-react'
import { autobind } from 'core-decorators'

interface IProps {
  store?: CalculatorStoreInstance
  backButtonHidden?: boolean
  nextButtonHidden?: boolean
  backButtonDisabled?: boolean
  nextButtonDisabled?: boolean
  onNextClick?: () => void
  onBackClick?: () => void
  onVideoTipClick?: () => void
  infoText?: string
  longInfoText?: string
}

interface IState {
  infoExpanded: boolean
}

@inject('store')
export class SideInformation extends React.Component<IProps, IState> {
  state: IState = {
    infoExpanded: false
  }

  @autobind
  private _onVideoTipClick () {
    this.props.store!.toggleVideo()
  }

  @autobind
  private _onInfoClick () {
    this.setState({ infoExpanded: !this.state.infoExpanded })
  }

  render () {
    return (<Container>
      {/*<Item onClick={this._onVideoTipClick} clickable>*/}
      {/*  <Icon src={Utils.getAssetPath('/assets/icons/video.svg')} />*/}
      {/*  <Headline>Videotipp</Headline>*/}
      {/*  <Text>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean</Text>*/}
      {/*</Item>*/}

      <Item>
        <Icon src={Utils.getAssetPath('/assets/icons/announcement.svg')} />
        <Headline>Wussten Sie schon, dass...</Headline>
        <Text>{this.props.infoText}</Text>
      </Item>

      <SideControls left>
        {!this.props.backButtonHidden && <SideControlsButton disabled={this.props.backButtonDisabled} onClick={this.props.onBackClick}>
          <SideControlsButtonContent>
            <SideControlsButtonIcon src={Utils.getAssetPath('/assets/icons/arrow.png')} flipped />
            Zurück
          </SideControlsButtonContent>
        </SideControlsButton>}
      </SideControls>

      <SideControls right>
        {!this.props.nextButtonHidden && <SideControlsButton primary disabled={this.props.nextButtonDisabled} onClick={this.props.onNextClick}>
          <SideControlsButtonContent>
            <SideControlsButtonIcon src={Utils.getAssetPath('/assets/icons/arrow.png')} />
            Weiter
          </SideControlsButtonContent>
        </SideControlsButton>}
        {/*<SideControlsButton onClick={this._onVideoTipClick}>*/}
        {/*  <SideControlsButtonIcon src={Utils.getAssetPath('/assets/icons/video-white-small.png')} />*/}
        {/*  Videotipp*/}
        {/*</SideControlsButton>*/}
        <InfoButton onClick={this._onInfoClick} expanded={this.state.infoExpanded}>
          <SideControlsButtonExpandedContent>
            <Headline>Wussten Sie schon, dass...</Headline>
            <Text>{this.props.longInfoText}</Text>
          </SideControlsButtonExpandedContent>
          <SideControlsButtonContent>
            <SideControlsButtonIcon src={Utils.getAssetPath('/assets/icons/info.png')} />
            Info
          </SideControlsButtonContent>
        </InfoButton>
      </SideControls>
    </Container>)
  }
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 0;
  padding: 40px 0;
  border-top: 1px solid ${props => props.theme.borderColor};
  ${breakpoint('tablet')`
    border-top: none;
    border-left: 1px solid ${props => props.theme.borderColor};
    flex: 0 1 250px;
    padding: 0; 
  `}
`

const Item = styled.div<{ clickable?: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 0 0 50%;  
  text-align: center;
  justify-content: center;
  padding: 0 20px;
  ${props => props.clickable && 'cursor: pointer;'};
`

const Headline = styled.h4`
  font-family: ${props => props.theme.headlineFont};
  font-weight: ${props => props.theme.headlineWeight};
  margin-bottom: 20px;
  font-size: 20px;  
`

const Icon = styled.img`
  width: 50px;
  margin: 0 auto 20px auto;
`

const SideControls = styled.div<{ left?: boolean, right?: boolean }>`
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  ${props => props.left && 'left: 0;'}
  ${props => props.right && 'right: 0;'}
  display: none;
  flex-direction: column;
  align-items: flex-end;
  ${breakpoint('tablet')`
    display: flex;
  `}
`

const SideControlsButton = styled.div<{ primary?: boolean, disabled?: boolean, expanded?: boolean }>`
  border-radius: 3px;
  width: ${props => props.expanded ? '530px' : '83px'};
  max-height: ${props => props.expanded ? '375px' : '86px'};
  background-color: ${props => props.primary ? props.theme.primaryColor : props.theme.lightTextColor};
  color: white;
  margin-bottom: 3px;
  cursor: pointer;
  font-size: 14px;
  opacity: ${props => props.disabled ? '0.5' : '1'};
  position: relative;
  transition: all 0.5s ease-out;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`

const SideControlsButtonContent = styled.div`
  width: 83px;
  height: 86px;
  flex: 0 0 83px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const SideControlsButtonIcon = styled.img<{ flipped?: boolean }>`
  height: 25px;
  margin-bottom: 10px;
  ${props => props.flipped && 'transform: rotate(180deg);'}
`

const InfoButton = styled(SideControlsButton)`
  
`

const SideControlsButtonExpandedContent = styled.div`
  flex: 0 0 435px;
  text-align: center;
  padding: 20px 30px;
`
